const CURRENT_OFFERS_ADMIN_PATHS = new Set([
  'current-hostince',
  'aktualne-zajazdy',
  'aktualni-zajezdy',
]);

function normalizeMenuPath(path?: string) {
  const value = path?.trim();
  if (!value) return '';

  try {
    const pathname = value.includes('://') ? new URL(value).pathname : value;
    return pathname.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
  } catch {
    return value.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
  }
}

export function isOrganizedOffersMenuItem(path?: string) {
  return path?.trim() === '#';
}

export function isCurrentOffersMenuItem(path: string | undefined, toursRoute: string) {
  const normalizedPath = normalizeMenuPath(path);
  if (!normalizedPath || isOrganizedOffersMenuItem(path)) return false;

  return (
    normalizedPath === normalizeMenuPath(toursRoute) ||
    CURRENT_OFFERS_ADMIN_PATHS.has(normalizedPath)
  );
}
